import styled from "styled-components";
import React from "react";
import { SelectedEvidence } from "./SelectedEvidence";

export function ConfirmedEvidence({ selectedEvidence, onRemoveEvidence }) {
  return (
    <ConfirmedEvidencePanel>
      <HeaderLayout>
        <Header>Confirmed Evidence:</Header>
      </HeaderLayout>
      <SelectedEvidenceLayout>
        {selectedEvidence.map((ev, i) => (
          <StyledEvidence
            key={i}
            evidence={ev}
            onRemoveEvidence={onRemoveEvidence}
          ></StyledEvidence>
        ))}
      </SelectedEvidenceLayout>
    </ConfirmedEvidencePanel>
  );
}
const SelectedEvidenceLayout = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  @media (max-width: 750px) {
    overflow: hidden;
  }
`;
const ConfirmedEvidencePanel = styled.div`
  border: 1px solid #5181ac;
  margin: 25px;
  @media (max-width: 750px) {
    margin: 10px;
  }
`;
const Header = styled.div`
  margin-right: auto;
  margin-left: 5px;
  @media (max-width: 750px) {
    font-size: 14px;
  }
`;

const HeaderLayout = styled.div`
  display: flex;
`;
const StyledEvidence = styled(SelectedEvidence)``;
export const AppLayout = styled.div`
  width: 100%;
  height: 100%;
`;
